// extracted by mini-css-extract-plugin
module.exports = {"dropdown__item":"DropDownItem_dropdown__item__1Kghr","icon":"DropDownItem_icon__2Hvjh","icon_active":"DropDownItem_icon_active__nS2S9"};